import { Mail, Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const RELEASES = [
  {
    date: 'Feb 2026',
    title: 'AutoTrust Ghana launches AI-powered car marketplace',
    body: 'AutoTrust Ghana announces the public availability of its AI-backed automotive marketplace, pairing verified seller identity with escrow payments and ML fraud detection. The platform serves all 16 regions at launch.',
  },
  {
    date: 'Feb 2026',
    title: 'In-app price negotiation goes live',
    body: 'Buyers can now send offers directly from any listing, and sellers receive instant accept / reject / counter controls. Each offer is timestamped and email-notified.',
  },
  {
    date: 'Feb 2026',
    title: 'Video walkarounds added to listings',
    body: 'Sellers can now upload a short video walkaround alongside photos. Videos are server-side compressed and indexed for buyer search.',
  },
];

export default function Press() {
  return (
    <main data-testid="press-page">
      <section className="max-w-5xl mx-auto px-4 md:px-8 pt-16 md:pt-24 pb-10">
        <p className="text-xs tracking-[0.18em] uppercase text-gold mb-3 font-medium">Press &amp; news</p>
        <h1 className="text-4xl md:text-6xl font-bold leading-[1.05] tracking-tight">
          For journalists and analysts.
        </h1>
        <p className="mt-5 text-base md:text-lg text-muted-foreground max-w-2xl">
          Press releases, brand assets, and an open inbox for media inquiries.
        </p>
      </section>

      <section className="max-w-5xl mx-auto px-4 md:px-8 py-10 md:py-12 border-t border-border/40">
        <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground mb-6">Releases</p>
        <div className="divide-y divide-border/50">
          {RELEASES.map((r, i) => (
            <article key={i} className="py-6 md:py-8 grid md:grid-cols-[140px_1fr] gap-4 md:gap-8" data-testid={`press-release-${i}`}>
              <p className="text-sm text-muted-foreground md:pt-1">{r.date}</p>
              <div>
                <h3 className="text-lg md:text-xl font-semibold tracking-tight mb-2">{r.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{r.body}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 md:px-8 py-12 md:py-16 border-t border-border/40">
        <div className="rounded-2xl border border-border/50 bg-card p-6 md:p-8 grid md:grid-cols-[1fr_auto] gap-6 items-center" data-testid="press-index-promo">
          <div>
            <p className="text-xs uppercase tracking-[0.15em] text-gold mb-2">AutoTrust Index</p>
            <h3 className="text-xl md:text-2xl font-bold tracking-tight mb-2">Monthly Ghana auto market data</h3>
            <p className="text-sm text-muted-foreground max-w-2xl">
              Pricing by make, fastest-selling segments, and regional demand &mdash; auto-generated from anonymised transactions.
              Reproduction permitted with attribution.
            </p>
          </div>
          <Link to="/index"><Button className="bg-gold text-black hover:brightness-110 font-semibold gap-2 whitespace-nowrap" data-testid="press-index-cta">View the Index <Mail className="w-4 h-4 hidden" /></Button></Link>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 md:px-8 py-12 md:py-16 border-t border-border/40 grid md:grid-cols-2 gap-10">
        <div>
          <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground mb-2">Media inquiries</p>
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight mb-3">Talk to our press team.</h2>
          <p className="text-muted-foreground mb-5">We respond to all credentialed media inquiries within one business day.</p>
          <a href="mailto:press@autotrustgh.com">
            <Button className="bg-gold text-black hover:brightness-110 font-semibold gap-2" data-testid="press-contact-btn">
              <Mail className="w-4 h-4" /> press@autotrustgh.com
            </Button>
          </a>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground mb-2">Brand assets</p>
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight mb-3">Logos &amp; guidelines.</h2>
          <p className="text-muted-foreground mb-5">High-resolution logos, screenshots, and brand colour reference.</p>
          <a href="mailto:press@autotrustgh.com?subject=Brand%20assets%20request">
            <Button variant="outline" className="gap-2" data-testid="press-assets-btn"><Download className="w-4 h-4" /> Request assets</Button>
          </a>
        </div>
      </section>
    </main>
  );
}
